import { LOCAL_STORAGE_USER_LOGIN_INFO, ORDER_BY, ODER_BY_TYPE, ResponseCode } from "@app/constants/Common";
import { EmailInviteMode } from "@app/pages/candidate/list/DVTJCUVEmailInviteModal";
import { Button } from "@components";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useState } from 'react';
import UpdateDVTJCUVPipelineModal from '@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal';

const DVTJCUVPipelineNextStragyCompaignGroupItemList = (props) => {
    const { pipelineIds, initialPipelines, nextFUStrategy, nextFUCompaign, parentTab, mode, onEmailFU } = props
    const [pipelines, setPipelines] = useState(initialPipelines || []);
    const [selectedPipelines, setSelectedPipelines] = useState([]);
    const [showUpdatePipelineModal, setShowUpdatePipelineModal] = useState(false);
    const [selectPipeline, setSelectPipeline] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [sortPipeColumns, setSortPipeColumns] = useState({
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    });

    useEffect(() => {
        setPipelines(initialPipelines || []);
    }, [initialPipelines]);

    const fetchPipelineList = async (ids, sortColumns) => {
        const params = {
            search_conditions: {
                parent_tab: parentTab && parentTab.id,
                pipeline_ids: ids,
                unlimited: true
            },
            sort_columns: sortColumns
        }
        const res = await requestGetDVTJCUVPipeLineList(params);
        if (res.sts_code === ResponseCode.SUCCESS) {
            setPipelines(res.content.pipelines || []);
        }
    }

    const onEmailFUHandle = async () => {
        onEmailFU(selectedPipelines)
    }


    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    const onSelectItems = (items) => {
        setSelectedPipelines([...items])
    }

    const onSortPipelines = async (columnKey) => {
        let sortColumns = { ...sortPipeColumns }
        if (sortColumns[columnKey] && sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
            sortColumns[columnKey] = ODER_BY_TYPE.DESC
        } else {
            sortColumns = {}
            sortColumns[columnKey] = ODER_BY_TYPE.ASC
        }

        setSortPipeColumns(sortColumns)
        await fetchPipelineList(pipelineIds, sortColumns)
    }

    const getBtnEmailFuTitle = () => {
        if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
            return "Email Mời gửi job (FU)"
        }
        return "Email FU"
    }

    const getNextFUStrategyTitle = () => {
        if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
            return "(REC) FU Strategy (Next time)"
        }
        return "FU Strategy (Next time)"
    }

    const getNextFUCompaignTitle = () => {
        if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
            return "(REC) FU Compaign (Next time)"
        }
        return "FU Compaign (Next time)"
    }

    const onShowEditPipeline = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectPipeline({ ...item })
        setShowUpdatePipelineModal(true)
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <span className='card-title'>
                        {getNextFUStrategyTitle()}: <b>{nextFUStrategy}</b>
                    </span>
                    <div className='card-title ml-5'>
                        {getNextFUCompaignTitle()}: <b>{nextFUCompaign}</b>
                    </div>
                    <div className={'card-tools'}>

                        <Button
                            className={'btn-sm btn-info'}
                            onClick={onEmailFUHandle}
                            disabled={selectedPipelines.length === 0}
                        >
                            {getBtnEmailFuTitle()}
                        </Button>
                    </div>
                </div>
                <div className='card-body p-0'>
                    <DVTJCUVPipelineTableList
                        pipeLines={pipelines}
                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_ACQUIRE_CDD}
                        showBtnSelect
                        hideColumns={[]}
                        parentTabId={parentTab.id}
                        onSelectItems={(items => {
                            onSelectItems(items)
                        })}
                        onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                        onSort={onSortPipelines}
                        sortColumn={sortPipeColumns}
                    />
                </div>
            </div>
            {showUpdatePipelineModal &&
                <UpdateDVTJCUVPipelineModal isShow={showUpdatePipelineModal}
                    pipeLineInfo={selectPipeline}
                    onClose={(reload) => setShowUpdatePipelineModal(false)}
                />
            }
        </>
    )
}

export default DVTJCUVPipelineNextStragyCompaignGroupItemList;
